import { useState } from "react";

import { useToken } from "../../context/AuthContext";
import { fetchOriginalReport } from "../../utils/originalReport";
import { FaChevronDown, FaFileAlt, FaSpinner } from "../../utils/icons";

// Collapsible panel that lazy-fetches the original radiologist report for a
// study. Lives at the bottom of the report tab in PrototypeReport.
export function OriginalReportPanel({ studyId }: { studyId: string }) {
  const [expanded, setExpanded] = useState(false);
  const [reportText, setReportText] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const token = useToken();

  const handleToggle = () => {
    if (!expanded && !fetched) {
      setLoading(true);
      fetchOriginalReport(studyId, token ?? "")
        .then((data) => {
          setReportText(data.available ? (data.report_text ?? null) : null);
          setFetched(true);
        })
        .catch(() => setFetched(true))
        .finally(() => setLoading(false));
    }
    setExpanded(!expanded);
  };

  return (
    <div className="original-report-panel">
      <button className="to-consider-toggle" onClick={handleToggle}>
        {expanded ? (
          <FaChevronDown className="w-3 h-3" />
        ) : (
          <FaFileAlt className="w-3 h-3 opacity-50" />
        )}
        <span>Original Report</span>
      </button>
      {expanded && (
        <div className="px-3 py-2">
          {loading ? (
            <div className="flex items-center gap-2 text-fg-muted text-xs">
              <FaSpinner className="w-3 h-3 animate-spin" />
              <span>Loading original report...</span>
            </div>
          ) : reportText ? (
            <pre className="text-xs text-fg-muted leading-relaxed whitespace-pre-wrap font-sans max-h-[300px] overflow-y-auto">
              {reportText}
            </pre>
          ) : (
            <span className="text-xs text-fg-muted italic">
              No original report available for this study.
            </span>
          )}
        </div>
      )}
    </div>
  );
}
